"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../../atoms/Icon");
var _Table = require("./Table.styled");
var _jsxRuntime = require("react/jsx-runtime");
var TableHeaderCell = function TableHeaderCell(_ref) {
  var children = _ref.children,
    size = _ref.size,
    align = _ref.align,
    fixed = _ref.fixed,
    isSorted = _ref.isSorted,
    direction = _ref.direction,
    onClick = _ref.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table.TableHeaderCellWrapper, {
    onClick: onClick,
    size: size,
    align: align,
    fixed: fixed,
    isSorted: isSorted,
    children: [children, isSorted ? direction === 'asc' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'chevronDown',
      color: 'brand'
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'chevronUp',
      color: 'brand'
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'placeholder'
    })]
  });
};
TableHeaderCell.defaultProps = {};
var _default = exports.default = TableHeaderCell;